import classNames from "classnames";
import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";

import { TrashIcon } from "../../AscIcons";

import styles from "./AscDoubleTextQuestionAnswerForm.module.scss";

export interface AscDoubleTextQuestionAnswerFormProps {
  className?: string;
  onChange: (value: Partial<Record<"question" | "answer", string>>) => void;
  value: Partial<Record<"question" | "answer", string>>;
  onDelete?: () => void;
  canDelete?: boolean;
  answerLabel?: string;
  questionLabel?: string;
}

export default function AscDoubleTextQuestionAnswerForm({
  className,
  onChange,
  onDelete,
  canDelete = false,
  value,
  answerLabel = "Answer",
  questionLabel = "Question",
}: AscDoubleTextQuestionAnswerFormProps) {
  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <div className={classNames(styles.formField, styles.questionField)}>
          <label className={styles.fieldLabel} htmlFor="question">
            {questionLabel}
          </label>
          <div className={classNames(styles.inputField)}>
            <AscTextInput
              className={styles.input}
              fullWidth={true}
              placeholder={`Enter ${questionLabel?.toLowerCase()}`}
              value={value?.question}
              onChange={(e) => onChange?.({ question: e?.target?.value })}
            />
          </div>
        </div>

        <div className={styles.formField}>
          <label className={styles.fieldLabel} htmlFor="answer">
            {answerLabel}
          </label>
          <div className={styles.inputField}>
            <AscTextInput
              fullWidth={true}
              placeholder={`Enter ${answerLabel?.toLowerCase()}`}
              value={value?.answer}
              onChange={(e) => onChange?.({ answer: e?.target?.value })}
            />

            <hr className={styles.hR} />

            <TrashIcon
              onClick={canDelete ? onDelete : undefined}
              className={classNames(styles.trashIcon, {
                [styles.iconDisabled]: !canDelete,
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
